import mainImage from './hatch.jpg';
import image1 from './hatch1.jpg';
import image2 from './hatch2.jpg';
import image3 from './hatch3.jpg';
import image4 from './hatch4.jpg';

const details = [
    { 
      id: 2,
      name: 'Hatch Ok-to-Wake Light',
      slideTitle: 'Hatch Ok-to-Wake Light',
      slideImage: mainImage,
      images: [mainImage, image1, image2, image3, image4],
      description: 'Another household favorite of mine is the Hatch sound machine. I started out with one about 5 years ago, and now have another one as well. We\'ve used the sounds to replace an old sound machine, but the colors to move into the "okay to wake" phase. Now at age 7, my older daughter doesn\'t need the okay to wake for the most part — only an occasional very early morning for her these days, but overall this did help to slowly shift her wake up time back. She used to wake up at 5 am every day, and now she rarely wakes up before 6 am, but more regularly between 6:30 and 7. Since she no longer needs the okay to wake colors, she has chosen to have the lights go through rainbow mode and have assorted colors. Note: if you\'re planning to travel with yours and fly, I highly recommend the travel case.',
      link:'https://amzn.to/48oFIrU',
    }
]

export default details[0];